/**
 * Implementation of Monitor Alert page
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import StepFour from "../../../components/CreateMonitor/StepFour";

export default function MonitorAlert() {

  return (
    <div className="flex">
      <div className="w-1/3 bg-accent rounded-tl-xl rounded-bl-xl flex flex-col pt-28 items-center">
        {/* <img src={Welcome} width={200} className="mb-4"/> */}
        <h1 className="text-2xl text-white mb-4">Welcome Harsh!</h1>
        <p className="text-center text-white">You can monitor your API, Website and SSL certificates.</p>
      </div>
      <div className="flex-1 p-8">
        <h1 className="text-2xl my-4 text-center">Where should we alert you</h1>
        <StepFour />
      </div>
    </div>
  )
}